import React from 'react';
import { Header, HeaderProps } from 'src/components/core/Header/Header';
import styles from './Page.module.scss';

interface PageProps {
  header: HeaderProps;
}

export const Page: React.FC<PageProps> = ({ header, children }) => {

  return (
    <div className={styles['c-page']}>
      <Header {...header} />
      <main className={styles['c-page__main']}>{children}</main>
    </div>
  );
};
